export const normalizeNumber = (value, oldValue) => value.match(/^(([0-9]+[.]?[0-9]*)|)$/) ? value : oldValue
